import { Component } from 'react';

import { LocalStorage } from 'saddlebag-localstorage';

import BpkButton from '@skyscanner/backpack-web/bpk-component-button';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import { withI18n } from '../../../../services/i18n';

import RecentSearchItem from './RecentSearchItem';

import type { I18nShape } from '../../../../services/i18n';
import type { RecentSearchShape } from '../../../../types';

import STYLES from './RecentSearches.scss';

type Props = {
  i18n: I18nShape;
  onSuggestionSelected: Function;
  onSuggestionsClearRequested?: Function;
  onBlur: Function;
  isMobile?: boolean;
};

type State = {
  expanded: boolean;
};

const defaultProps = {
  onSuggestionsClearRequested: undefined,
  isMobile: false,
};

const cls = cssModules(STYLES);
const localStorage = new LocalStorage('hotelsWebsiteLocalStorage');

const INITIAL_SHOW_VALUE = 2;
const TERMINAL_SHOW_VALUE = 5;

class RecentSearches extends Component<Props, State> {
  static defaultProps = defaultProps;

  constructor(props: Props) {
    super(props);

    this.state = {
      expanded: false,
    };
  }

  toggle = (e: Event) => {
    e.stopPropagation();
    this.setState((prevState) => ({
      expanded: !prevState.expanded,
    }));
  };

  render() {
    const recentItems = localStorage.tryGetValue('recentSearchItems');
    const recentSearchItemsList =
      (recentItems && JSON.parse(recentItems)) || [];

    const NumRecentSearch = recentSearchItemsList.length;
    if (!NumRecentSearch) {
      return null;
    }

    if (NumRecentSearch === 1 && !recentSearchItemsList[0].destination) {
      return null;
    }
    const { expanded } = this.state;
    const {
      i18n,
      isMobile,
      onBlur,
      onSuggestionSelected,
      onSuggestionsClearRequested,
    } = this.props;

    const showMoreButton = recentSearchItemsList.length > INITIAL_SHOW_VALUE;
    const showMax = expanded ? TERMINAL_SHOW_VALUE : INITIAL_SHOW_VALUE;
    const viewMoreLessLabelKey = expanded
      ? 'Button_viewLess'
      : 'HotelImageGallery_label_viewAll';

    const recentSearchesList = recentSearchItemsList
      .slice(0, showMax)
      .map((item: RecentSearchShape, index: number) => (
        <RecentSearchItem
          index={index}
          item={item}
          onBlur={onBlur}
          onSuggestionSelected={onSuggestionSelected}
          onSuggestionsClearRequested={onSuggestionsClearRequested}
          isMobile={!!isMobile}
        />
      ));

    return (
      <section>
        <div className={cls('RecentSearches__recentSearchHeader')}>
          <div className={cls('RecentSearches__recentTitle')}>
            {i18n.translate('Auto_Suggest_recentSearch_label')}
          </div>
          {showMoreButton && (
            <div className={cls('RecentSearches__btn')}>
              <BpkButton link onClick={this.toggle}>
                {i18n.translate(viewMoreLessLabelKey)}
              </BpkButton>
            </div>
          )}
        </div>
        <div className={cls('RecentSearches__recentSearchItems')}>
          {recentSearchesList}
        </div>
      </section>
    );
  }
}

export default withI18n(RecentSearches);
